function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19.5517L12.4385 19.1689C16.1258 15.9492 18 13.1379 18 10.6667C18 7.16713 15.2686 4.66669 12 4.66669C8.73137 4.66669 6 7.16713 6 10.6667C6 13.1379 7.87421 15.9492 11.5615 19.1689L12 19.5517ZM12 17.7756C8.87107 14.9557 7.33333 12.5662 7.33333 10.6667C7.33333 7.93109 9.44274 6.00002 12 6.00002C14.5573 6.00002 16.6667 7.93109 16.6667 10.6667C16.6667 12.5662 15.1289 14.9557 12 17.7756ZM12 7.33335C13.8409 7.33335 15.3333 8.82574 15.3333 10.6667C15.3333 12.5076 13.8409 14 12 14C10.1591 14 8.66667 12.5076 8.66667 10.6667C8.66667 8.82574 10.1591 7.33335 12 7.33335ZM10 10.6667C10 9.56212 10.8954 8.66669 12 8.66669C13.1046 8.66669 14 9.56212 14 10.6667C14 11.7713 13.1046 12.6667 12 12.6667C10.8954 12.6667 10 11.7713 10 10.6667Z",
  fill: "#006AFF"
});

function SvgPinNewThemePickupDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgPinNewThemePickupDetails);
export default __webpack_public_path__ + "static/media/pin-new-theme-pickup-details.3430180f.svg";
export { ForwardRef as ReactComponent };